import React, { useCallback, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";

export function RouterPrompt(props) {
  const { when, onOK, onCancel, setShowPrompt, title, text } = props;

  const history = useHistory();
  const params = useParams();

  const [currentPath, setCurrentPath] = useState("");

  useEffect(() => {
    if (!props.disabled) {
      history.block((prompt) => {
        setCurrentPath(prompt.pathname);
        setShowPrompt(true);
      });
    } else {
      history.block(() => {});
      setShowPrompt(false);
    }

    // return () => {
    //   history.block(() => {});
    // };
  }, [history, props.disabled]);

  const handleOK = () => {
    if (props.newVersion) {
      setShowPrompt(false);
      props.handleNewVersion();

      history.push(props.newPath);
    } else if (props.isUpdate) {
      setShowPrompt(false);
      props.handleSaveOrder();

      history.push(props.newPath);
    } else {
      props.saveAnswer();

      if (!props.forwarded.length > 0) {
        history.goBack();
      }
    }
  };

  const handleCancel = useCallback(async () => {
    if (onCancel) {
      const canRoute = await Promise.resolve(onCancel());
      if (canRoute) {
        history.block(() => {});
        history.push(currentPath);
        props.handleDisabled();
        setCurrentPath("");
      }
    }
    setShowPrompt(false);
  }, [setShowPrompt, currentPath, history, onCancel]);
  const { t } = useTranslation();
  return (
    <Dialog
      open={when}
      onClose={handleCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {text}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="disabled" onClick={handleCancel}>
          {t("cancel")}
        </Button>
        <Button color="error" onClick={() => props.handleLeave()} autoFocus>
          {t("leave")}
        </Button>
        <Button color="success" onClick={handleOK} autoFocus>
          {t("save")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
